<template>
    <div class="common-container-fluid">
        <div class="login-item">
            <div class="left-part" >

                <div class="main-des">Welcome！</div>
                <div class="sub-des">支持已认证用户查询培训证书</div>
            </div>
            <div class="right-part">
                <div class="login-moudle">
                    <div class="title">
                        用户核验
                    </div>
                    <el-form
                        ref="trainingLoginForm"
                        :model="trainingLogin"
                        :rules="loginRules"
                        class="login-form"
                    >
                        <el-form-item prop="phone">
                            <el-input v-model="trainingLogin.phone" placeholder="请输入手机号">
                                <img class="btn-icon" src="../../assets/img/traning/phone.png"  alt="" slot="prefix"/>
                            </el-input>
                        </el-form-item>
                        <el-form-item
                            prop="captcha"
                            :error="checkCodeError"
                        >
                            <div class="item-content-pos form-identify">
                                <el-input v-model="trainingLogin.captcha" placeholder="请输入验证码">
                                    <img class="btn-icon" src="../../assets/img/traning/captcha.png"  alt="" slot="prefix"/>
                                </el-input>
                                <count-down class="identifying" @getCaptcha="getCaptcha" text="获取验证码" renewText='重新获取' :buttonType="'text'" :disabled="!trainingLogin.phone"></count-down>
                            </div>
                        </el-form-item>
                    </el-form>
                    <el-button type="primary" class="searchbtn" @click="onSearch">查询</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import trainingReq from "~/request/trainingReq";
import countDown from "./Components/count-down";

const checkPhone = (rule, value, callback) => {
  if (!value) {
    callback();
  } else if (!/^[1][0-9]{10}$/.test(value)) {
    callback(new Error('请输入正确的手机号'));
  } else {
  }
};
export default {
    components: {
        countDown,
    },
    data() {
        return {
            checkFlag:false,
            trainingLogin: {
                phone: '',
                captcha: '',
            },
            checkCodeError: '',
            loginRules:{
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'change' },
                    { validator: checkPhone, trigger: 'change' },
                ],
                captcha:[
                    { required: true, message: '请输入验证码', trigger: 'change' },
                    { validator: this.checkCaptcha, trigger: 'change' }
                ] 
            },
        }
    },
    methods: {
        checkCaptcha(rule, value, callback){
            if (!value) {
                this.checkFlag = false;
                return callback('验证码不能为空');
            }
            var reg = /^\d{6}$/;
            if (!reg.test(value)) {
                this.checkFlag = false;
                return callback('请输入正确的验证码')
            }
            let param = {
                'phone':this.trainingLogin.phone,
                'code':value
            };
            trainingReq.verifyPhoneCode(param)
            .then(res => {
                if (!res.res) {
                    this.checkFlag = false;
                    return callback(res.msg);
                } else {
                    this.checkFlag = true;
                    return callback();
                }
            })
            .catch(err => {
                console.error(err);
                this.checkFlag = false;
                return callback(new Error('验证码校验错误'));
            });
        },
        getCaptcha() {
            trainingReq.sendPhoneCode({phone: this.trainingLogin.phone})
            .then(res => {
            if (res.code == '0') {
                this.$notify.success({
                title: '提示',
                message: res.msg || '验证码发送成功',
                });
            }
            })
            .catch(error => {
                console.error(error);
            });
        },
        onSearch() {
            if(this.checkFlag){
                let param = {
                    'phone':this.trainingLogin.phone,
                    'code':this.trainingLogin.captcha
                };
                trainingReq
                    .loginByPhoneCode(param)
                    .then(res => {
                    if (res.code == '0') {
                        this.$notify({
                            title: '成功',
                            message: res.msg || '登录成功',
                            type: 'success',
                        });
                        localStorage.setItem('token', res.res.token);
                        localStorage.setItem('userId', res.res.id);
                        this.$router.push('/trainCert/detail?id='+ res.res.id);
                    }
                })
                .catch(error => {
                    this.$notify({
                        title: '失败',
                        message: '登录失败',
                        type: 'error',
                    });
                });
            } else {
                this.$notify({
                    title: '失败',
                    message: '请输入正确的手机号和验证码',
                    type: 'error',
                });

            }
        },
    },
    created() {
    
    },
    computed: {
    },
    mounted() {
    },
    watch: {
    }
};
</script>
<style lang="less" scoped>
.common-container-fluid {
    background-image: url("../../assets/img/traning/loginbg.png");
    background-size: cover;
    height: 100%;
    width: 100%;

}

.login-item {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 100vw;
}
.right-part {
    width: 529px;
    height: 598px;
    background: #FFFFFF;
    .login-moudle {
        padding: 70px 66px;
        .title {
            font-weight: 500;
            font-size: 24px;
            color: rgba(0,0,0,0.9);
            line-height: 33px;
            text-align: left;
            font-style: normal;
            margin-bottom: 66px;
        }
        .login-form {
            img.btn-icon {
                width: 16px;
                height: 16px;
                padding: 13px 7px;
                opacity: 0.6;
            }
            /deep/input.el-input__inner {
                font-size: 14px;
                padding: 11px 17px 11px 34px;
                height: 42px !important;
            }
            /deep/.el-form-item--small.el-form-item {
                margin-bottom: 25px;
            }
            /deep/.el-form-item--small .el-form-item__error {
                padding-top: 9px;
            }
            .form-identify {
                position: relative;
            }
            .form-identify .el-input{
                width:100%;
            }
            .form-identify .identifying {
                background: none;
                position: absolute;
                right: 30px;
                top:1px;
                /deep/.el-button--small {
                    font-size: 14px !important;
                    padding: 11px 0 !important;

                }
                /deep/.el-button--text {
                    color: #ab13a5;
                }
            }
        }
    }
}

.left-part {
    width: 529px;
    height: 598px;
    background-image: url("../../assets/img/traning/loginleft.png");
    background-size: cover;
    .main-des {
        font-weight: bold;
        font-size: 36px;
        color: #000000;
        line-height: 46px;
        letter-spacing: 3px;
        text-align: left;
        font-style: normal;
        margin: 48px 51px 5px;
    }
    .sub-des {
        margin-left: 51px;
        font-weight: 400;
        font-size: 16px;
        color: #000000;
        line-height: 22px;
        letter-spacing: 1px;
        text-align: left;
        font-style: normal;
    }
}
.searchbtn {
    background-color: #ab13a5;
    border-color: #ab13a5;
    width:100%;
    margin-top: 116px;
    padding: 12px 15px !important;
    font-size: 16px;
}

</style>